export default __webpack_public_path__ + "static/media/espanish.b7d46e1f.svg";